import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, MapPin, Calendar, Package } from "lucide-react";
import { money } from "@/lib/api";

export default function Confirmation() {
  const [order, setOrder] = useState(null);
  useEffect(() => {
    try { setOrder(JSON.parse(sessionStorage.getItem("tfl_last_order"))); } catch { /* noop */ }
  }, []);

  if (!order) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-24 text-center">
        <h1 className="font-heading text-2xl font-bold text-foreground">Aucune commande récente</h1>
        <Link to="/menu" className="mt-6 inline-block px-6 py-3 rounded-full bg-primary text-primary-foreground font-heading font-semibold">Commander</Link>
      </div>
    );
  }

  const f = order.fulfillment;
  const fmtDate = (s) => { try { return new Date(s + "T00:00:00").toLocaleDateString("fr-CA", { weekday: "long", day: "numeric", month: "long", year: "numeric" }); } catch { return s; } };

  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 py-14">
      <div className="text-center animate-fade-up">
        <div className="h-20 w-20 rounded-full bg-foreground/10 border border-border flex items-center justify-center mx-auto mb-5">
          <CheckCircle2 className="h-11 w-11 text-foreground" />
        </div>
        <h1 className="font-heading text-3xl font-extrabold text-foreground" data-testid="confirmation-title">Commande confirmée !</h1>
        <p className="text-muted-foreground mt-2">Merci {order.contact.name}. Nous vous contacterons pour toute question.</p>
        <p className="mt-4 inline-block px-4 py-2 rounded-full bg-foreground/5 border border-border font-heading font-bold text-coral" data-testid="confirmation-number">
          Commande n° {order.order_number}
        </p>
      </div>

      <div className="mt-8 rounded-2xl bg-ink-800 border border-border p-6 space-y-4">
        <div className="flex items-center gap-3">
          <Calendar className="h-5 w-5 text-coral" />
          <div>
            <p className="text-sm text-muted-foreground">{f.mode === "livraison" ? "Livraison" : "Cueillette"}</p>
            <p className="text-foreground font-medium">{fmtDate(f.date)}{f.time ? ` · ${f.time}` : ""}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <MapPin className="h-5 w-5 text-coral" />
          <div>
            <p className="text-sm text-muted-foreground">{f.mode === "livraison" ? "Adresse de livraison" : "Lieu de cueillette"}</p>
            <p className="text-foreground font-medium">{f.mode === "livraison" ? `${f.address}, ${f.city} ${f.postal_code}` : "374 Saint Joseph, St-Raymond, QC G3L 1J9"}</p>
          </div>
        </div>

        <div className="h-px bg-foreground/10" />
        <div className="space-y-3">
          {order.items.map((i, idx) => (
            <div key={idx} className="flex items-center gap-3 text-sm">
              <img src={i.image} alt="" className="h-11 w-11 rounded-lg object-cover" />
              <div className="flex-1"><p className="text-foreground">{i.nom}</p><p className="text-muted-foreground text-xs">{i.quantity} × {money(i.prix)}</p></div>
              <span className="text-muted-foreground">{money(i.prix * i.quantity)}</span>
            </div>
          ))}
        </div>
        <div className="h-px bg-foreground/10" />
        <div className="space-y-1.5 text-sm">
          <div className="flex justify-between text-muted-foreground"><span>Sous-total</span><span>{money(order.subtotal)}</span></div>
          <div className="flex justify-between text-muted-foreground"><span>Livraison</span><span>{order.delivery_fee ? money(order.delivery_fee) : "Gratuit"}</span></div>
          <div className="flex justify-between font-heading font-bold text-foreground text-lg pt-1"><span>Total</span><span className="text-coral">{money(order.total)}</span></div>
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground pt-1">
          <Package className="h-4 w-4" /> Paiement à la {f.mode === "livraison" ? "livraison" : "cueillette"} — paiement en ligne bientôt disponible.
        </div>
      </div>

      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/menu" className="px-6 py-3 rounded-full bg-primary text-primary-foreground hover:opacity-90 font-heading font-semibold transition-colors">Nouvelle commande</Link>
        <Link to="/compte" className="px-6 py-3 rounded-full glass border border-border font-heading font-semibold hover:bg-foreground/10 transition-colors">Mes commandes</Link>
      </div>
    </div>
  );
}
